<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocDropDownDefinitionCodeApe'
});
</script>
<template>
  <ka-container
    code="bloc-drop-down-definition-code-ape"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Deroule -->
    <ka-container
      code="deroule"
      :options="{
        click: componentInstance.derouleClick,
        $state: { selected: $isEqual(componentInstance.$elements['definition']?.style.hidden, componentInstance.$constants.definitionHidden) }
      }"
      :selected="{ click: componentInstance.derouleClickWhenSelected }">
      <!-- Titre -->
      <ka-container code="titre">
        <ka-text
          code="votre-code-ape-activite"
          :xs-value="componentInstance.$title.value">
          <h3 v-html="t('blocDropDownDefinitionCodeApe.deroule.titre.votreCodeApeActivite.value', `Votre code APE (activité principale exercée) `)" />
        </ka-text>
        <ka-icon
          code="icone-developper-4"
          :options="{ $inheritState: { selected: true } }"
          value="i-fa-solid:angle-down" />
      </ka-container>
    </ka-container>
    <!-- Définition -->
    <ka-container
      code="definition"
      :options="{
        animationIn: `fadeIn`,
        hidden: null
      }">
      <ka-text
        code="le-code-naf-figure"
        :xs-value="componentInstance.$text.value">
        <span v-html="t('blocDropDownDefinitionCodeApe.definition.leCodeNafFigure.value', `Le code NAF figure sur l'extrait K-bis de l'entreprise. Il est composé de 4 chiffres + 1 lettre. Les deux premiers chiffres concernent le secteur d'activité de l'entreprise. Le troisième et le quatrième chiffre indiquent avec plus de précision l'activité exercée.<br> <br>Le code APE permet d'<strong>identifier la branche d'activité </strong>principale de votre entreprise. Il est <strong>attribué automatiquement par l'Insee</strong> lors de la création d'une entreprise. L'attribution se fait en fonction de la description de l'activité qui a été déclarée au CFE (centre de formalités des entreprises). Vous n'avez aucune demande à effectuer pour l'obtenir.<br> <br><i>Depuis le 1er janvier 2023, le CFE est remplacé par le guichet unique des entreprises. Le code APE détermine la convention collective qui s'applique à vos salariés.</i>`)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocDropDownDefinitionCodeApeComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c34')
const component = blocDropDownDefinitionCodeApeComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  text?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: '',
  text: 'Le code NAF figure sur l\'extrait K-bis de l\'entreprise. Il est composé de 4 chiffres + 1 lettre. Les deux premiers chiffres concernent le secteur d\'activité de l\'entreprise. Le troisième et le quatrième chiffre indiquent avec plus de précision l\'activité exercée.<br> <br>Le code APE permet d\'<strong>identifier la branche d\'activité </strong>principale de votre entreprise. Il est <strong>attribué automatiquement par l\'Insee</strong> lors de la création d\'une entreprise. L\'attribution se fait en fonction de la description de l\'activité qui a été déclarée au CFE (centre de formalités des entreprises). Vous n\'avez aucune demande à effectuer pour l\'obtenir.<br> <br><i>Depuis le 1er janvier 2023, le CFE est remplacé par le guichet unique des entreprises. Le code APE détermine la convention collective qui s\'applique à vos salariés.</i>',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title',
  'update:text'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    title: true,
    text: true
  }
})
</script>
